import React, { useState, useCallback } from 'react';
import AsyncSelect from 'react-select-v3/async';
import * as http from 'utils/http';
import config from 'config';
import debouncePromise from 'debounce-promise';
import serialize from 'utils/serialize';

const t = {
  placeholder: 'Select staff user',
};

const getOperators = (input) => {
  const params = {
    search: input,
    page_size: 0,
    is_active: true,
    fields: 'url,email,name,id,preferences',
  };

  return http.get(`${config.API_URL}staff_users/?${serialize(params)}`);
};

const UsersSelect = ({ onChange }) => {
  const [value, setValue] = useState(undefined);

  const handleChange = useCallback(
    (value) => {
      setValue(value);
      onChange(value);
    },
    [onChange]
  );

  const _getStaffUsers = useCallback(async (input) => {
    if (!input || input.length < 3) {
      return Promise.resolve([]);
    }

    const staffUsers = await getOperators(input);

    return staffUsers.map((operator) => operator);
  }, []);

  const getStaffUsers = debouncePromise(_getStaffUsers, 500, {
    leading: true,
  });

  const getOptionLabel = (option) => option.name;
  const getOptionValue = (option) => option.id;

  return (
    <AsyncSelect
      isClearable
      placeholder={t.placeholder}
      value={value}
      onChange={handleChange}
      loadOptions={getStaffUsers}
      autoFocus
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
    />
  );
};

export default UsersSelect;
